export default __webpack_public_path__ + "static/media/icons-metaverses-voxels.c944ebc7.svg";